/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-unused-expressions */
export const eventEmitter = {
  events: {},
  register(event, cb) {
    this.unSubscribe(event, cb)
    if (!this.events[event]) {
      this.events[event] = []
    }
    this.events[event].push({ [cb]: cb })
  },
  emit(event, data) {
    if (!this.events[event]) {
      return
    }
    this.events[event].forEach((cbObj) => {
      for (const cb in cbObj) {
        cbObj[cb](data)
      }
    })
  },
  unSubscribe(event, cb) {
    if (this.events[event] && Array.isArray(this.events[event])) {
      this.events[event] = this.events[event].filter((cbObj) => !cbObj[cb])
      if (this.events[event].length <= 0) {
        delete this.events[event]
      }
    }
    if (cb === true) {
      delete this.events[event]
    }
  },
}
